<template>
  <div class="chart">
    <ApexChart
      v-if="chartOptions"
      :key="key"
      :options="chartOptions"
      :series="series"
      :height="height"
      type="bar"
      @click="click"
    />
    <BlockLoader :loading="loading" />
  </div>
</template>

<script>
import ApexChart from "vue3-apexcharts";
import BlockLoader from "@/components/blocks/BlockLoader.vue";

export default {
  name: "ColumnBarChartComponent",
  props: {
    datas: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  components: {
    BlockLoader,
    ApexChart,
  },
  data() {
    return {
      chartOptions: null,
      series: [],
      key: 0,
      height: 350,
    };
  },
  emits: ["click"],
  watch: {
    datas() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    click(e, context, options) {
      this.$emit("click", options.dataPointIndex);
    },
    init() {
      if (this.datas?.options) {
        this.chartOptions = this.datas.options;
        this.height = this.datas.options.chart.height;
      }
      if (this.datas?.series) {
        this.series = this.datas.series;
      }
      this.key++;
    },
  },
};
</script>

<style scoped></style>
